var _rect, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgInfo = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1325_4344",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1325_4344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.25 34H26.25V22H22.25V34ZM24.25 18C24.8167 18 25.2917 17.8083 25.675 17.425C26.0583 17.0417 26.25 16.5667 26.25 16C26.25 15.4333 26.0583 14.9583 25.675 14.575C25.2917 14.1917 24.8167 14 24.25 14C23.6833 14 23.2083 14.1917 22.825 14.575C22.4417 14.9583 22.25 15.4333 22.25 16C22.25 16.5667 22.4417 17.0417 22.825 17.425C23.2083 17.8083 23.6833 18 24.25 18ZM24.25 44C21.4833 44 18.8833 43.475 16.45 42.425C14.0167 41.375 11.9 39.95 10.1 38.15C8.3 36.35 6.875 34.2333 5.825 31.8C4.775 29.3667 4.25 26.7667 4.25 24C4.25 21.2333 4.775 18.6333 5.825 16.2C6.875 13.7667 8.3 11.65 10.1 9.85C11.9 8.05 14.0167 6.625 16.45 5.575C18.8833 4.525 21.4833 4 24.25 4C27.0167 4 29.6167 4.525 32.05 5.575C34.4833 6.625 36.6 8.05 38.4 9.85C40.2 11.65 41.625 13.7667 42.675 16.2C43.725 18.6333 44.25 21.2333 44.25 24C44.25 26.7667 43.725 29.3667 42.675 31.8C41.625 34.2333 40.2 36.35 38.4 38.15C36.6 39.95 34.4833 41.375 32.05 42.425C29.6167 43.475 27.0167 44 24.25 44ZM24.25 40C28.7167 40 32.5 38.45 35.6 35.35C38.7 32.25 40.25 28.4667 40.25 24C40.25 19.5333 38.7 15.75 35.6 12.65C32.5 9.55 28.7167 8 24.25 8C19.7833 8 16 9.55 12.9 12.65C9.8 15.75 8.25 19.5333 8.25 24C8.25 28.4667 9.8 32.25 12.9 35.35C16 38.45 19.7833 40 24.25 40Z",
    fill: "#455CC7"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/info.e8c2d036.svg";
export { ForwardRef as ReactComponent };